import axios from 'axios';
import config from '../config'

const Login = {
    state:{
              status: '',
           token: localStorage.getItem('token') || '',
           user: [],
           error: false,
           msg: ''
        
    },
    mutations: {
        auth_request(state){
            state.status = 'loading'
        },
        auth_success(state, token, user){
         state.status = 'success'
         state.token = token
         state.user = user
        },
        auth_error(state) {
            state.status = 'error'
        },
        logout(state) {
            state.status = ''
            state.token = ''
        },
        USERINFO: (state, user) => state.user = user,
        ERROR: (state, error) => state.error = error,
        MSG: (state, msg) => state.msg = msg
    },
    actions: {
        async login({commit}, data){
           await axios({
                method:'post',
                url: config.BASE_LOGIN,
                data: data
            })
            .then((resp) => {
                console.log(resp);
                const token =  resp.data.token
                const user = resp.data.user
                const isLogin = true
                const type =    'application/json'
                localStorage.setItem('token', token)
                localStorage.setItem('loginer', isLogin)
                localStorage.setItem('user', JSON.stringify(user))
                axios.defaults.headers.common['Authorization'] = token
                axios.defaults.headers.common['Content-Type'] = type
                commit('auth_success', token, user)
                commit('USERINFO', user)
               commit('ERROR', resp.data.error)
               commit('MSG', resp.data.msg)
            }).catch((err) => {
                commit('auth_error')
                localStorage.removeItem('token')
                localStorage.removeItem('user')
            });
        },
    
        logout({commit}){
            return new Promise((resolve, reject) => {
                commit('logout')
                localStorage.removeItem('token')
                localStorage.removeItem('user')
                localStorage.removeItem('loginer')
                delete axios.defaults.headers.common['Authorization']
                resolve()
            });
        }
    },
    getters : {
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
        getLoginError: state => state.error,
        getLoginMsg: state => state.msg,
        getUserItem: state => state.user
      }
}

export default Login;